export const stackTokens = { childrenGap: 10 };
export const HeaderMargin = { childrenGap: 5 };

export const centerStyle = {
	alignItems: 'center',
	display: 'flex',
	justifyContent: 'center',
};

export const parentStackStyles = {
	root: {
		height: '100%',
		width: '100%',
		background: 'transparent',
		alignContent: 'center',
	},
};

export const iconContainerStyle = {
	display: 'flex',
	flex: 1,
	alignItems: 'center',
	justifyContent: 'space-evenly',
	flexWrap: 'wrap',
	width: '100%',
	margin: '0 0 0 0',
};
